/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getClient = /* GraphQL */ `query GetClient($id: ID!) {
  getClient(id: $id) {
    id
    ownerUserId
    name
    slug
    inviteLink
    userRole
    defaultWorkspaces
    meta
    created_at
    customer_id
    subscription_plan
    subscription_status
    subscription_endsAt
    subscription_details
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetClientQueryVariables, APITypes.GetClientQuery>;
export const listClients = /* GraphQL */ `query ListClients(
  $id: ID
  $filter: ModelClientFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listClients(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      ownerUserId
      name
      slug
      inviteLink
      userRole
      defaultWorkspaces
      meta
      created_at
      customer_id
      subscription_plan
      subscription_status
      subscription_endsAt
      subscription_details
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClientsQueryVariables,
  APITypes.ListClientsQuery
>;
export const syncClients = /* GraphQL */ `query SyncClients(
  $filter: ModelClientFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncClients(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      ownerUserId
      name
      slug
      inviteLink
      userRole
      defaultWorkspaces
      meta
      created_at
      customer_id
      subscription_plan
      subscription_status
      subscription_endsAt
      subscription_details
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncClientsQueryVariables,
  APITypes.SyncClientsQuery
>;
export const getClientUser = /* GraphQL */ `query GetClientUser($id: ID!) {
  getClientUser(id: $id) {
    ownerId
    id
    email
    sub
    name
    surname
    isAdmin
    isReadOnly
    roles
    roleUpdatedBy
    isConfirmed
    avatarPath
    closedAt
    lastActive
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClientUserQueryVariables,
  APITypes.GetClientUserQuery
>;
export const listClientUsers = /* GraphQL */ `query ListClientUsers(
  $id: ID
  $filter: ModelClientUserFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listClientUsers(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      ownerId
      id
      email
      sub
      name
      surname
      isAdmin
      isReadOnly
      roles
      roleUpdatedBy
      isConfirmed
      avatarPath
      closedAt
      lastActive
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClientUsersQueryVariables,
  APITypes.ListClientUsersQuery
>;
export const syncClientUsers = /* GraphQL */ `query SyncClientUsers(
  $filter: ModelClientUserFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncClientUsers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      ownerId
      id
      email
      sub
      name
      surname
      isAdmin
      isReadOnly
      roles
      roleUpdatedBy
      isConfirmed
      avatarPath
      closedAt
      lastActive
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncClientUsersQueryVariables,
  APITypes.SyncClientUsersQuery
>;
export const clientUserByEmail = /* GraphQL */ `query ClientUserByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelClientUserFilterInput
  $limit: Int
  $nextToken: String
) {
  clientUserByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      ownerId
      id
      email
      sub
      name
      surname
      isAdmin
      isReadOnly
      roles
      roleUpdatedBy
      isConfirmed
      avatarPath
      closedAt
      lastActive
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientUserByEmailQueryVariables,
  APITypes.ClientUserByEmailQuery
>;
export const clientUserBySub = /* GraphQL */ `query ClientUserBySub(
  $sub: String!
  $sortDirection: ModelSortDirection
  $filter: ModelClientUserFilterInput
  $limit: Int
  $nextToken: String
) {
  clientUserBySub(
    sub: $sub
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      ownerId
      id
      email
      sub
      name
      surname
      isAdmin
      isReadOnly
      roles
      roleUpdatedBy
      isConfirmed
      avatarPath
      closedAt
      lastActive
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClientUserBySubQueryVariables,
  APITypes.ClientUserBySubQuery
>;
export const getClientUserInvite = /* GraphQL */ `query GetClientUserInvite($id: ID!) {
  getClientUserInvite(id: $id) {
    ownerId
    id
    email
    isAdmin
    isReadOnly
    roles
    isInviteConfirmed
    inviteLink
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClientUserInviteQueryVariables,
  APITypes.GetClientUserInviteQuery
>;
export const listClientUserInvites = /* GraphQL */ `query ListClientUserInvites(
  $id: ID
  $filter: ModelClientUserInviteFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listClientUserInvites(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      ownerId
      id
      email
      isAdmin
      isReadOnly
      roles
      isInviteConfirmed
      inviteLink
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClientUserInvitesQueryVariables,
  APITypes.ListClientUserInvitesQuery
>;
export const syncClientUserInvites = /* GraphQL */ `query SyncClientUserInvites(
  $filter: ModelClientUserInviteFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncClientUserInvites(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      ownerId
      id
      email
      isAdmin
      isReadOnly
      roles
      isInviteConfirmed
      inviteLink
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncClientUserInvitesQueryVariables,
  APITypes.SyncClientUserInvitesQuery
>;
export const getWorkspace = /* GraphQL */ `query GetWorkspace($id: ID!) {
  getWorkspace(id: $id) {
    ownerId
    id
    name
    slug
    avatarPath
    childIds
    archivedIds
    trashedIds
    pinnedIds
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkspaceQueryVariables,
  APITypes.GetWorkspaceQuery
>;
export const listWorkspaces = /* GraphQL */ `query ListWorkspaces(
  $id: ID
  $filter: ModelWorkspaceFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listWorkspaces(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      ownerId
      id
      name
      slug
      avatarPath
      childIds
      archivedIds
      trashedIds
      pinnedIds
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkspacesQueryVariables,
  APITypes.ListWorkspacesQuery
>;
export const syncWorkspaces = /* GraphQL */ `query SyncWorkspaces(
  $filter: ModelWorkspaceFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncWorkspaces(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      ownerId
      id
      name
      slug
      avatarPath
      childIds
      archivedIds
      trashedIds
      pinnedIds
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncWorkspacesQueryVariables,
  APITypes.SyncWorkspacesQuery
>;
export const getWorkspaceUser = /* GraphQL */ `query GetWorkspaceUser($id: ID!) {
  getWorkspaceUser(id: $id) {
    ownerId
    workspaceId
    userId
    role
    createdAt
    updatedAt
    createdBy
    updatedBy
    id
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkspaceUserQueryVariables,
  APITypes.GetWorkspaceUserQuery
>;
export const listWorkspaceUsers = /* GraphQL */ `query ListWorkspaceUsers(
  $filter: ModelWorkspaceUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listWorkspaceUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      ownerId
      workspaceId
      userId
      role
      createdAt
      updatedAt
      createdBy
      updatedBy
      id
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWorkspaceUsersQueryVariables,
  APITypes.ListWorkspaceUsersQuery
>;
export const syncWorkspaceUsers = /* GraphQL */ `query SyncWorkspaceUsers(
  $filter: ModelWorkspaceUserFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncWorkspaceUsers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      ownerId
      workspaceId
      userId
      role
      createdAt
      updatedAt
      createdBy
      updatedBy
      id
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncWorkspaceUsersQueryVariables,
  APITypes.SyncWorkspaceUsersQuery
>;
export const wsUserByWsId = /* GraphQL */ `query WsUserByWsId(
  $ownerId: ID!
  $workspaceIdUserId: ModelWorkspaceUserByWorkspaceCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelWorkspaceUserFilterInput
  $limit: Int
  $nextToken: String
) {
  wsUserByWsId(
    ownerId: $ownerId
    workspaceIdUserId: $workspaceIdUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      ownerId
      workspaceId
      userId
      role
      createdAt
      updatedAt
      createdBy
      updatedBy
      id
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WsUserByWsIdQueryVariables,
  APITypes.WsUserByWsIdQuery
>;
export const wsUserByUserId = /* GraphQL */ `query WsUserByUserId(
  $ownerId: ID!
  $userId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelWorkspaceUserFilterInput
  $limit: Int
  $nextToken: String
) {
  wsUserByUserId(
    ownerId: $ownerId
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      ownerId
      workspaceId
      userId
      role
      createdAt
      updatedAt
      createdBy
      updatedBy
      id
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WsUserByUserIdQueryVariables,
  APITypes.WsUserByUserIdQuery
>;
export const getItem = /* GraphQL */ `query GetItem($id: ID!) {
  getItem(id: $id) {
    ownerId
    workspaceId
    id
    name
    type
    childIds
    parentIds
    readRoles
    writeRoles
    creator
    pinned
    trashed
    archived
    statusUpdatedBy
    ackUpdatedBy
    acknowledgementRequired
    acknowledgement
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetItemQueryVariables, APITypes.GetItemQuery>;
export const listItems = /* GraphQL */ `query ListItems(
  $id: ID
  $filter: ModelItemFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listItems(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      ownerId
      workspaceId
      id
      name
      type
      childIds
      parentIds
      readRoles
      writeRoles
      creator
      pinned
      trashed
      archived
      statusUpdatedBy
      ackUpdatedBy
      acknowledgementRequired
      acknowledgement
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListItemsQueryVariables, APITypes.ListItemsQuery>;
export const syncItems = /* GraphQL */ `query SyncItems(
  $filter: ModelItemFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncItems(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      ownerId
      workspaceId
      id
      name
      type
      childIds
      parentIds
      readRoles
      writeRoles
      creator
      pinned
      trashed
      archived
      statusUpdatedBy
      ackUpdatedBy
      acknowledgementRequired
      acknowledgement
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncItemsQueryVariables, APITypes.SyncItemsQuery>;
export const getEvent = /* GraphQL */ `query GetEvent($id: ID!) {
  getEvent(id: $id) {
    id
    ownerId
    workspaceId
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetEventQueryVariables, APITypes.GetEventQuery>;
export const listEvents = /* GraphQL */ `query ListEvents(
  $id: ID
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEvents(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      ownerId
      workspaceId
      initiatorId
      type
      meta
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEventsQueryVariables,
  APITypes.ListEventsQuery
>;
export const syncEvents = /* GraphQL */ `query SyncEvents(
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncEvents(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      ownerId
      workspaceId
      initiatorId
      type
      meta
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncEventsQueryVariables,
  APITypes.SyncEventsQuery
>;
export const getNotification = /* GraphQL */ `query GetNotification($id: ID!) {
  getNotification(id: $id) {
    id
    ownerId
    userId
    eventId
    status
    channelAttempts
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationQueryVariables,
  APITypes.GetNotificationQuery
>;
export const listNotifications = /* GraphQL */ `query ListNotifications(
  $id: ID
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listNotifications(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      ownerId
      userId
      eventId
      status
      channelAttempts
      initiatorId
      type
      meta
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationsQueryVariables,
  APITypes.ListNotificationsQuery
>;
export const syncNotifications = /* GraphQL */ `query SyncNotifications(
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncNotifications(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      ownerId
      userId
      eventId
      status
      channelAttempts
      initiatorId
      type
      meta
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncNotificationsQueryVariables,
  APITypes.SyncNotificationsQuery
>;
export const notifByUser = /* GraphQL */ `query NotifByUser(
  $ownerId: ID!
  $userIdCreatedAt: ModelNotificationByClientCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  notifByUser(
    ownerId: $ownerId
    userIdCreatedAt: $userIdCreatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ownerId
      userId
      eventId
      status
      channelAttempts
      initiatorId
      type
      meta
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotifByUserQueryVariables,
  APITypes.NotifByUserQuery
>;
export const getDocument = /* GraphQL */ `query GetDocument($id: ID!) {
  getDocument(id: $id) {
    ownerId
    id
    docVersion
    content
    latestEditor
    trashed
    archived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDocumentQueryVariables,
  APITypes.GetDocumentQuery
>;
export const listDocuments = /* GraphQL */ `query ListDocuments(
  $id: ID
  $filter: ModelDocumentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDocuments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      ownerId
      id
      docVersion
      content
      latestEditor
      trashed
      archived
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDocumentsQueryVariables,
  APITypes.ListDocumentsQuery
>;
export const syncDocuments = /* GraphQL */ `query SyncDocuments(
  $filter: ModelDocumentFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncDocuments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      ownerId
      id
      docVersion
      content
      latestEditor
      trashed
      archived
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncDocumentsQueryVariables,
  APITypes.SyncDocumentsQuery
>;
export const searchDocuments = /* GraphQL */ `query SearchDocuments(
  $filter: SearchableDocumentFilterInput
  $sort: [SearchableDocumentSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableDocumentAggregationInput]
) {
  searchDocuments(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      ownerId
      id
      itemId
      docVersion
      trashed
      archived
      highlight {
        content
        __typename
      }
      latestEditor
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchDocumentsQueryVariables,
  APITypes.SearchDocumentsQuery
>;
